"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const layout_1 = require("@chakra-ui/layout");
const menu_1 = require("@chakra-ui/menu");
const system_1 = require("@chakra-ui/system");
const libphonenumber_js_1 = require("libphonenumber-js");
const countries_1 = __importStar(require("./countries"));
const SearchOnList_1 = require("./SearchOnList");
const CaretDownIcon_1 = __importDefault(require("../icons/CaretDownIcon"));
const CaretUpIcon_1 = __importDefault(require("../icons/CaretUpIcon"));
const Input_1 = require("../Input");
const Typography_1 = __importDefault(require("../Typography"));
function parseNumberInfo(parsedCountryNumber, supportedCountries) {
    const [dialCode, ...rest] = parsedCountryNumber.split(' ');
    const hasPlusPrefix = parsedCountryNumber.startsWith('+');
    const number = hasPlusPrefix ? rest.join(' ') : '';
    const country = supportedCountries.find(country => country.dialCode === dialCode);
    return {
        number,
        country,
    };
}
const FormInputPhoneNumber = (_a) => {
    var _b;
    var { onChange, onBlur, defaultCountry, defaultNumber = '', errorMessage, disabled = false, placeholder, size = 'lg', countryCodes = ['AU', 'NZ', 'US', 'CA', 'GB'] } = _a, props = __rest(_a, ["onChange", "onBlur", "defaultCountry", "defaultNumber", "errorMessage", "disabled", "placeholder", "size", "countryCodes"]);
    const supportedCountries = (0, react_1.useMemo)(() => (countryCodes === 'all' ? countries_1.default : (0, countries_1.getCountriesByCountryCodes)(countryCodes)), [countryCodes]);
    const ref = (0, react_1.useRef)(null);
    const styles = (0, system_1.useMultiStyleConfig)('FormInputPhoneNumber', {});
    const defaultNumberInfo = (0, react_1.useMemo)(() => parseNumberInfo(new libphonenumber_js_1.AsYouType().input(defaultNumber), supportedCountries), [defaultNumber, supportedCountries]);
    const [countryObj, setCountryObj] = (0, react_1.useState)((_b = defaultNumberInfo.country) !== null && _b !== void 0 ? _b : countries_1.countryMap.get(defaultCountry));
    const [number, setNumber] = (0, react_1.useState)(defaultNumberInfo.number);
    const onBlurHandler = () => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(new libphonenumber_js_1.AsYouType().input(`${countryObj === null || countryObj === void 0 ? void 0 : countryObj.dialCode}${number}`));
    };
    const onCountryChange = (item) => {
        const parsedCountryNumber = new libphonenumber_js_1.AsYouType().input(`${item.dialCode}${number}`);
        setCountryObj(item);
        onChange(parsedCountryNumber);
    };
    const onPhoneNumberChange = (event) => {
        const value = event.target.value;
        const parsedCountryNumber = new libphonenumber_js_1.AsYouType().input(`${countryObj === null || countryObj === void 0 ? void 0 : countryObj.dialCode}${value}`);
        const parsedNumberInfo = parseNumberInfo(parsedCountryNumber, supportedCountries);
        setNumber(parsedNumberInfo.number);
        onChange(parsedCountryNumber);
    };
    return ((0, jsx_runtime_1.jsx)(layout_1.Box, Object.assign({ position: "relative", ref: ref }, { children: (0, jsx_runtime_1.jsx)(menu_1.Menu, Object.assign({ gutter: 0 }, { children: ({ isOpen }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Input_1.InputGroup, Object.assign({ sx: styles.group, size: size, onBlur: onBlurHandler }, { children: [(0, jsx_runtime_1.jsx)(Input_1.Input, Object.assign({ sx: styles.input, variant: "outline", type: "tel", value: number, onChange: onPhoneNumberChange, isInvalid: !!errorMessage, disabled: disabled, placeholder: placeholder }, props)), (0, jsx_runtime_1.jsx)(Input_1.InputLeftElement, Object.assign({ as: menu_1.MenuButton, type: "button", disabled: disabled, sx: styles.leftElement, _focus: { shadow: 'outline' } }, { children: (0, jsx_runtime_1.jsxs)(layout_1.Box, Object.assign({ as: "span", display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(layout_1.Text, { children: countryObj === null || countryObj === void 0 ? void 0 : countryObj.flag }), (0, jsx_runtime_1.jsxs)(layout_1.Text, Object.assign({ sx: styles.dialCode }, { children: [" ", countryObj === null || countryObj === void 0 ? void 0 : countryObj.dialCode, " "] })), isOpen ? (0, jsx_runtime_1.jsx)(CaretUpIcon_1.default, {}) : (0, jsx_runtime_1.jsx)(CaretDownIcon_1.default, {})] })) }))] })), errorMessage && ((0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "body3", sx: styles.error }, { children: errorMessage }))), (0, jsx_runtime_1.jsx)(SearchOnList_1.SearchOnList, { data: supportedCountries, selectedCountryCode: countryObj === null || countryObj === void 0 ? void 0 : countryObj.code, onChange: onCountryChange })] })) })) })));
};
exports.default = FormInputPhoneNumber;
